/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Pressable, View, Icon } from '@components/atoms'
import { mono, boShared, boSize } from '@components/systems/backoffice/backoffice.tokens'

interface PropsType {
	onBackClick: () => void
}

/** 패스워드 안내 — 한 컬럼, 헤어라인 행. 닫기는 텍스트 + × */
export const ForgotPasswordMessage = (props: PropsType) => {
	const onBackClick = () => {
		props.onBackClick()
	}

	return (
		<View css={style}>
			<View className="inner">
				<View className="head">
					<span className="boKicker">Password</span>
					<Pressable className="backButton" onClick={onBackClick}>
						<span>돌아가기</span>
						<Icon name="close" className="backIcon" />
					</Pressable>
				</View>
				<h1 className="title">패스워드를 잊어버렸다.</h1>
				<p className="boLead lead">
					본 시스템 계정은 (주)넥센 그룹웨어 계정(AD 계정)과 동일하다.
				</p>

				<ol className="steps">
					<li className="step">
						<span className="stepNo">01</span>
						<span>사용중인 사내 컴퓨터의 패스워드를 확인한다.</span>
					</li>
					<li className="step">
						<span className="stepNo">02</span>
						<span>컴퓨터 패스워드를 변경해 본다.</span>
					</li>
					<li className="step">
						<span className="stepNo">03</span>
						<span>그래도 해결이 되지 않으면 문의한다.</span>
					</li>
				</ol>
			</View>
		</View>
	)
}

const style = css({
	...boShared,
	flex: 1,
	width: '100%',
	padding: `clamp(24px, 6vh, 64px) ${boSize.gutter} 96px`,

	'.inner': { maxWidth: 640, margin: '0 auto' },

	'.head': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',

		'.backButton': {
			display: 'flex',
			alignItems: 'center',
			gap: 6,
			padding: '0 4px 0 8px',
			height: 32,
			fontSize: 13,
			fontWeight: 500,
			color: mono.dim,
			'.backIcon': { fontSize: 18, color: 'inherit' },
			'&:hover': { color: mono.ink },
		},
	},

	'.title': {
		marginTop: 12,
		fontSize: 'clamp(28px, 3.2vw, 40px)',
		fontWeight: 200,
		lineHeight: 1.1,
		letterSpacing: '-0.01em',
	},
	'.lead': { marginTop: 16 },

	'.steps': {
		listStyle: 'none',
		margin: '32px 0 0',
		padding: 0,
		borderTop: `1px solid ${mono.line}`,

		'.step': {
			display: 'flex',
			alignItems: 'baseline',
			gap: 20,
			padding: '16px 0',
			borderBottom: `1px solid ${mono.line}`,
			fontSize: 14,
			fontWeight: 300,
			color: mono.ink,

			'.stepNo': {
				flexShrink: 0,
				fontSize: 11,
				letterSpacing: '.22em',
				color: mono.faint,
				fontVariantNumeric: 'tabular-nums',
			},
		},
	},
})
